import { subsPresetsGenerator } from '../../../utils/subs';
import { GLOBAL_EXPORT_BUTTON_ENABLED } from '../../../constants/user';

export const INITIAL_FILTERS_STATE = {
  sort_by: 'title',
  order: 'asc',
};

export const NETWORK_PRESETS_PAGE_INFO = {
  title: 'Network Presets',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
];

export const NETWORK_PRESETS_CATEGORIES = [
  {
    value: '',
    label: 'None',
  },
  { value: 'Gambling', label: 'Gambling' },
  { value: 'CPI', label: 'CPI' },
  { value: 'Pin-submits', label: 'Pin-submits' },
  { value: 'Leadgen', label: 'Leadgen' },
  { value: 'Adult', label: 'Adult' },
  { value: 'Dating', label: 'Dating' },
  { value: 'E-commerce', label: 'E-commerce' },
  { value: 'Installs', label: 'Installs' },
  { value: 'Forex / Binary', label: 'Forex / Binary' },
  { value: 'Sweepstakes', label: 'Sweepstakes' },
  { value: 'Nutra', label: 'Nutra' },
  { value: 'Travel', label: 'Travel' },
  { value: 'Carriers', label: 'Carriers' },
  { value: 'Social', label: 'Social' },
  { value: 'Games', label: 'Games' },
  { value: 'Merchants', label: 'Merchants' },
  { value: 'Downloads', label: 'Downloads' },
  { value: 'Education', label: 'Education' },
  { value: 'E-mail submits', label: 'E-mail submits' },
  { value: 'Financial', label: 'Financial' },
  { value: 'Free stuff', label: 'Free stuff' },
  { value: 'Health and Fitness', label: 'Health and Fitness' },
  { value: 'Holidays', label: 'Holidays' },
  { value: 'Insurance', label: 'Insurance' },
  { value: 'Legal', label: 'Legal' },
  { value: 'Mobile Apps', label: 'Mobile Apps' },
  { value: 'Psychic/Medium', label: 'Psychic/Medium' },
  { value: 'Real Estate', label: 'Real Estate' },
  { value: 'Surveys', label: 'Surveys' },
  { value: 'Business', label: 'Business' },
  { value: 'Religion and Spirituality', label: 'Religion and Spirituality' },
  { value: 'News', label: 'News' },
  { value: 'Sports', label: 'Sports' },
  { value: 'Style and Fashion', label: 'Style and Fashion' },
  { value: 'Technology', label: 'Technology' },
  { value: 'Computing', label: 'Computing' },
];

export const NETWORK_PRESETS_ROLES = [
  {
    value: '',
    label: 'None',
  },
  { value: 'fbe', label: 'Event ID' },
  { value: 'fbfn', label: 'First Name' },
  { value: 'fbln', label: 'Last Name' },
  { value: 'fbph', label: 'Phone' },
  { value: 'fbge', label: 'Gender' },
  { value: 'fbem', label: 'Email' },
  { value: 'fbzi', label: 'Zip Code' },
  { value: 'fbbd', label: 'Birthday' },
  { value: 'fbci', label: 'Content IDs' },
  { value: 'fbco', label: 'Contents' },
  { value: 'fbcn', label: 'Product name' },
  { value: 'fbcc', label: 'Content Category' },
  { value: 'profit_margin', label: 'Profit margin' },
];

export const NETWORK_PRESETS_ACCOUNT_TYPES = [
  { value: 0, label: 'All' },
  { value: 1, label: 'E-commerce' },
  { value: 2, label: 'Affiliate' },
];

export const NETWORK_PRESETS_FORM_INITIAL_DATA = {
  id: '',
  alias: '',
  account_type: 0,

  // main
  title: '',
  url: '',
  logo: '',
  presetCategories: [],
  // settings
  postback_url: '',
  clickid: '',
  sum: '',
  offer_url: '',
  // contact
  contact: {
    person: '',
    email: '',
    phone: '',
    messenger: '',
  },
  referral_link: '',
  comment: '',
  // subs
  subs: subsPresetsGenerator(),
};

export const getNetworkPresetsMainFields = (categoriesOptions = []) => [
  {
    type: 'textField',
    label: 'Title',
    name: 'title',
    placeholder: 'Title',
  },
  {
    type: 'textField',
    label: 'Url',
    name: 'url',
    placeholder: 'Url',
  },
  {
    type: 'textField',
    label: 'Logo',
    name: 'logo',
    placeholder: 'Logo',
  },
  {
    type: 'select',
    label: 'Account type',
    name: 'account_type',
    options: NETWORK_PRESETS_ACCOUNT_TYPES,
  },
  {
    type: 'multiselect',
    label: 'Categories',
    name: 'categories',
    placeholder: 'Categories',
    options: [
      ...NETWORK_PRESETS_CATEGORIES,
    ],
    className: 'multiselect',
  },
  {
    type: 'multiselect',
    label: 'Preset categories',
    name: 'presetCategories',
    placeholder: 'Preset categories',
    options: categoriesOptions,
    className: 'multiselect',
  },
];

export const NETWORK_PRESETS_SETTINGS_FIELDS = [
  {
    type: 'textField',
    label: 'Postback url',
    name: 'postback_url',
    placeholder: 'Postback url',
  },
  {
    type: 'textField',
    label: 'Click id macro',
    name: 'clickid',
    placeholder: 'Click id macro',
  },
  {
    type: 'textField',
    label: 'Sum macro',
    name: 'sum',
    placeholder: 'Sum macro',
  },
  {
    type: 'textField',
    label: 'Offer url template',
    name: 'offer_url',
    placeholder: 'Offer url template',
  },
  {
    type: 'textField',
    label: 'Alias',
    name: 'alias',
    placeholder: 'Alias',
  },
];

export const NETWORK_PRESETS_CONTACT_FIELDS = [
  {
    type: 'textField',
    label: 'Person',
    name: 'contact.person',
    placeholder: 'Person',
  },
  {
    type: 'textField',
    label: 'Email',
    name: 'contact.email',
    placeholder: 'Email',
  },
  {
    type: 'textField',
    label: 'Phone',
    name: 'contact.phone',
    placeholder: 'Phone',
  },
  {
    type: 'textField',
    label: 'Messenger',
    name: 'contact.messenger',
    placeholder: 'Messenger',
  },
  {
    type: 'textField',
    label: 'Referral link',
    name: 'referral_link',
    placeholder: 'Referral link',
  },
  {
    type: 'textField',
    label: 'Comment',
    name: 'comment',
    placeholder: 'Comment',
  },
];
